import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from './fetch.util';
import moment from 'moment-timezone';
import {fetchPurchases, purchasesRequest, purchasesResponse} from './purchase.actions';

export const PRODUCT_ENTITLEMENTS_REQUEST = 'PRODUCT_ENTITLEMENTS_REQUEST';
export const PRODUCT_ENTITLEMENTS_RESPONSE = 'PRODUCT_ENTITLEMENTS_RESPONSE';
export const PAYMENT_HISTORY_REQUEST = 'PAYMENT_HISTORY_REQUEST';
export const PAYMENT_HISTORY_RESPONSE = 'PAYMENT_HISTORY_RESPONSE';
export const PRODUCT_BILLING_STATUSES_REQUEST = 'PRODUCT_BILLING_STATUSES_REQUEST';
export const PRODUCT_BILLING_STATUSES_RESPONSE = 'PRODUCT_BILLING_STATUSES_RESPONSE';
export const PRODUCT_BILLING_RECORDS_REQUEST = 'PRODUCT_BILLING_RECORDS_REQUEST';
export const PRODUCT_BILLING_RECORDS_RESPONSE = 'PRODUCT_BILLING_RECORDS_RESPONSE';
export const AUTO_PAYMENT_REQUEST = 'AUTO_PAYMENT_REQUEST';
export const AUTO_PAYMENT_RESPONSE = 'AUTO_PAYMENT_RESPONSE';
export const VIRTUAL_ACCOUNT_HISTORY_REQUEST = 'VIRTUAL_ACCOUNT_HISTORY_REQUEST';
export const VIRTUAL_ACCOUNT_HISTORY_RESPONSE = 'VIRTUAL_ACCOUNT_HISTORY_RESPONSE';

export const PURCHASE_STATES = {
  COMPLETED: '완료',
  CANCELED: '취소',
  TRANSFERRED: '양도됨',
  REFUNDED: '환불',
};

export function productEntitlementsRequest() {
  return {
    type: PRODUCT_ENTITLEMENTS_REQUEST,
  };
}

export function productEntitlementsResponse(productEntitlements = []) {
  return {
    type: PRODUCT_ENTITLEMENTS_RESPONSE,
    productEntitlements,
  };
}

export function paymentHistoryRequest(pageNumber, startDate, endDate) {
  return {
    type: PAYMENT_HISTORY_REQUEST,
    pageNumber,
    startDate,
    endDate,
  };
}

export function paymentHistoryResponse(content, pageNumber, totalItemCount) {
  return {
    type: PAYMENT_HISTORY_RESPONSE,
    content,
    pageNumber,
    totalItemCount,
  };
}

export function productBillingStatuesRequest(pageNumber, startDate, endDate) {
  return {
    type: PRODUCT_BILLING_STATUSES_REQUEST,
    pageNumber,
    startDate,
    endDate,
  };
}

export function productBillingStatusesResponse(content, totalItemCount) {
  return {
    type: PRODUCT_BILLING_STATUSES_RESPONSE,
    content,
    totalItemCount,
  };
}

export function productBillingRecordsRequest(productEntitlementId, pageNumber) {
  return {
    type: PRODUCT_BILLING_RECORDS_REQUEST,
    productEntitlementId,
    pageNumber,
  };
}

export function productBillingRecordsResponse(content, totalItemCount) {
  return {
    type: PRODUCT_BILLING_RECORDS_RESPONSE,
    content,
    totalItemCount,
  };
}

export function autoPaymentRequest() {
  return {
    type: AUTO_PAYMENT_REQUEST,
  };
}

export function autoPaymentResponse(autoPayment) {
  return {
    type: AUTO_PAYMENT_RESPONSE,
    autoPayment,
  };
}

export function virtualAccountHistoryRequest() {
  return {
    type: VIRTUAL_ACCOUNT_HISTORY_REQUEST,
  };
}

export function virtualAccountHistoryResponse(virtualAccountHistories) {
  return {
    type: VIRTUAL_ACCOUNT_HISTORY_RESPONSE,
    virtualAccountHistories,
  };
}

export function fetchProductEntitlementsForCurrentUser() {
  return dispatch => {
    dispatch(productEntitlementsRequest());
    fetch(`${API_URL}/product-entitlements/current-user`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return [];
      })
      .catch(() => [])
      .then(entitlements => {
        dispatch(productEntitlementsResponse(entitlements));
      });
  };
}

export function fetchProductEntitlementsWithPurchasesForCurrentUser() {
  return dispatch => {
    dispatch(productEntitlementsRequest());
    fetch(`${API_URL}/product-entitlements/current-user`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => response.json())
      .then(entitlements => {
        dispatch(purchasesRequest());
        fetchPurchases(entitlements)
          .then(purchases => {
            dispatch(purchasesResponse(purchases));
          })
          .then(() => dispatch(productEntitlementsResponse(entitlements)));
      });
  };
}

export function fetchPaymentHistoryForCurrentUser(startDate, endDate, page) {
  startDate = moment(startDate).toISOString();
  endDate = moment(endDate).toISOString();
  return dispatch => {
    dispatch(paymentHistoryRequest(page, startDate, endDate));
    fetch(
      `${API_URL}/payment-records/current-user/page/${page - 1}?startDateTime=${startDate}&endDateTime=${endDate}`,
      {
        method: 'GET',
        headers: commonHeaders(),
      }
    )
      .then(commonErrorHandler)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return {};
      })
      .catch(() => {})
      .then(paymentHistory => {
        if (paymentHistory) {
          dispatch(paymentHistoryResponse(paymentHistory.content, page, paymentHistory.totalElements));
        }
      });
  };
}

export function fetchProductBillingStatusesForCurrentUser(startDate, endDate, page) {
  startDate = moment(startDate).toISOString();
  endDate = moment(endDate).toISOString();
  return dispatch => {
    dispatch(productBillingStatuesRequest(page, startDate, endDate));
    fetch(
      `${API_URL}/users/product-entitlements/current-user/page/${page -
        1}?startDateTime=${startDate}&endDateTime=${endDate}`,
      {
        method: 'GET',
        headers: commonHeaders(),
      }
    )
      .then(commonErrorHandler)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return [];
      })
      .catch(() => {})
      .then(productBillingStatuses => {
        if (productBillingStatuses) {
          dispatch(
            productBillingStatusesResponse(productBillingStatuses.content, productBillingStatuses.totalElements)
          );
        }
      });
  };
}

export function fetchProductBillingRecordsForCurrentUser(productEntitlementId, page) {
  return dispatch => {
    dispatch(productBillingRecordsRequest(productEntitlementId, page));
    fetch(
      `${API_URL}/product-billing-records/current-user/by-entitlement-id/${productEntitlementId}/page/${page - 1}`,
      {
        method: 'GET',
        headers: commonHeaders(),
      }
    )
      .then(commonErrorHandler)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return [];
      })
      .catch(() => {})
      .then(productBillingRecords => {
        if (productBillingRecords) {
          dispatch(productBillingRecordsResponse(productBillingRecords.content, productBillingRecords.totalElements));
        }
      });
  };
}

export function fetchVirtualAccountHistoryForCurrentUser() {
  return dispatch => {
    dispatch(virtualAccountHistoryRequest());
    fetch(`${API_URL}/virtual-account-histories/current-user`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return [];
      })
      .catch(() => [])
      .then(virtualAccountHistories => {
        dispatch(virtualAccountHistoryResponse(virtualAccountHistories));
      });
  };
}
